import React from 'react';

import styled from 'styled-components';

import { TextLink } from '@techstyle/react-components';
import { FormattedMessage } from '@techstyle/react-intl';

import LogoPillIcon from './LogoPillIcon';

const MemberSignInContainer = styled.div`
  display: flex;
  height: 32px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: ${props => props.theme.colors.lavender100};
  ${({ theme }) => theme.paragraph.variants.paragraph4Uppercase.textStyles};
`;

const StyledSignInLink = styled(TextLink)`
  ${({ theme }) => theme.links.variants.textLinkSecondary}
  font-weight: 600;
  text-decoration: underline !important;
  padding-left: 4px;
`;

const MemberSignInLinkButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  return (
    <MemberSignInContainer className={className}>
      <LogoPillIcon />
      <div>
        <FormattedMessage
          defaultMessage="ALREADY A MEMBER?"
          id="global_checkout.membership_already_member_question"
        />
        <StyledSignInLink onClick={onClick}>
          <FormattedMessage
            defaultMessage="SIGN IN"
            id="global_checkout.sign_in_button"
          />
        </StyledSignInLink>
      </div>
    </MemberSignInContainer>
  );
};

export default MemberSignInLinkButton;
